export enum WorkflowModes {
  Readonly = 0,
  Development = 1,
  ProcessExploring = 2,
  Debugging = 4,
}
